import React from 'react';
import {
  func, bool, string, node,
} from 'prop-types';

import openIcon from '../../../../../assets/icon-expand-open.svg';
import closeIcon from '../../../../../assets/icon-expand-close.svg';
import {
  ExpandControl,
  Icon,
  ChildrenContainer,
  ExpandText,
} from './card-expand.style';

/**
 * Expand Bar Component
 * @param {object} param - Object containing props
 * @param {func} param.onClick - Handle onClick events
 * @param {boolean} param.expanded - Signfies if this should be in expand state
 * @param {string} param.expandMessage - Message to show in expand bar
 * @param {node} param.children - Singualar HTML node to put next to the expand message
 * @param {string} param.testId - Testing id
 * @return {element}
 */
const Expand = ({
  onClick, expanded, expandMessage, children, testId,
}) => (
  <ExpandControl data-testid={testId} onClick={onClick}>
    <Icon src={expanded ? closeIcon : openIcon} height="25px" width="25px" />
    <ExpandText>{expandMessage}</ExpandText>
    {children
      && (
        <ChildrenContainer>
          {children}
        </ChildrenContainer>
      )}
  </ExpandControl>
);

Expand.propTypes = {
  onClick: func,
  expanded: bool,
  expandMessage: string,
  children: node,
  testId: string,
};

Expand.defaultProps = {
  onClick: () => { },
  expanded: false,
  expandMessage: '',
  children: null,
  testId: null,
};

export default Expand;
